export var BufferType;
(function (BufferType) {
    BufferType[BufferType["ArrayBuffer"] = 0] = "ArrayBuffer";
    BufferType[BufferType["ElementArrayBuffer"] = 1] = "ElementArrayBuffer";
})(BufferType || (BufferType = {}));
export class BufferAttributes {
    array;
    buffer;
    size;
    gl;
    constructor(gl, array, size) {
        this.array = array;
        this.buffer = gl.createBuffer();
        this.gl = gl;
        this.size = size;
    }
    dispose() {
        if (!this.buffer) {
            return;
        }
        this.gl.deleteBuffer(this.buffer);
        this.buffer = null;
    }
    update(type, isStatic = true) {
        this.gl.bindBuffer(type, this.buffer);
        this.gl.bufferData(type, this.array, isStatic ? this.gl.STATIC_DRAW : this.gl.DYNAMIC_DRAW);
    }
}
//# sourceMappingURL=BufferAttributes.js.map